<template>
	<PortfolioOverviewTable>
		<PortfolioOverviewTableRow
			v-for="(returnData, index) in props.data"
			:key="index"
			:class="[{ 'font-weight-bold': index === 2 }, 'bb']"
		>
			<template #label>
				{{ returnData.name }} <sup v-if="returnData.footnote">{{ returnData.footnote }}</sup>
			</template>
			<template #value>
				<div class="display-flex align-items-center radio-checkbox-item">
					<label>
						<span class="display-flex align-items-center">
							<span
								v-if="props.showReturnIndicator"
								:class="['mr-25', returnData.indicatorClass]"
								data-test="return-indicator"
							></span>
							<span class="mr-25">{{ returnData.return }}</span></span
						>
						<input
							v-model="selectedReturnType"
							:value="returnData.enum"
							:name="`return-${returnData.name}`"
							:data-test="`return-${returnData.name}`"
							type="radio"
							@change="handleClick(returnData)"
						/>
						<span class="mask"></span>
					</label>
				</div>
			</template>
		</PortfolioOverviewTableRow>
	</PortfolioOverviewTable>
</template>

<script setup lang="ts">
import { PerformanceReturnJumboChip, PerformanceReturnJumboChipEnum } from 'types/performance-portfolio';
import { ref, watch } from 'vue';
import PortfolioOverviewTable from './portfolio-overview-table.vue';
import PortfolioOverviewTableRow from './portfolio-overview-table-row.vue';

interface Props {
	data: Array<PerformanceReturnJumboChip>;
	selectedChip: PerformanceReturnJumboChipEnum;
	showReturnIndicator?: boolean;
}

interface Emits {
	(e: 'return-chip-selected', value: PerformanceReturnJumboChipEnum): void;
}

const props = withDefaults(defineProps<Props>(), {
	showReturnIndicator: true
});

const emits = defineEmits<Emits>();

const selectedReturnType = ref<PerformanceReturnJumboChipEnum>('NET_RETURN');

watch(
	() => props.selectedChip,
	(newSelection) => {
		selectedReturnType.value = newSelection;
	},
	{ immediate: true }
);

function handleClick(chip: PerformanceReturnJumboChip): void {
	emits('return-chip-selected', chip.enum);
}
</script>

<style lang="scss" scoped>
@use '../../../styles/components/performance-portfolio' as *;
.radio-checkbox-item {
	padding-right: 1.5rem;
	padding-left: 0;

	.mask {
		right: 0;
		left: unset !important;
	}
}
</style>
